import { QueryClient } from "react-query";

// Create a client
const queryClient = new QueryClient();

export default queryClient;
